<template>
  <div class="site-settings-view">
    <section class="settings-card">
      <div class="settings-card__head">
        <div>
          <h2>站点设置 Site Settings</h2>
          <p>维护官网全局名称、SEO、品牌图片、联系方式、社媒链接和页脚文字。</p>
        </div>
        <el-button size="small" :loading="loading" @click="loadSettings">刷新 Refresh</el-button>
      </div>

      <el-form ref="form" :model="form" label-position="top" v-loading="loading">
        <h3>基础信息 Basic</h3>
        <div class="form-grid">
          <el-form-item label="站点名称 Site Name">
            <el-input v-model.trim="form.siteName" />
          </el-form-item>
          <el-form-item label="联系电话 Contact Phone">
            <el-input v-model.trim="form.contactPhone" />
          </el-form-item>
        </div>

        <div class="form-grid">
          <el-form-item label="联系邮箱 Contact Email">
            <el-input v-model.trim="form.contactEmail" />
          </el-form-item>
          <el-form-item label="页脚署名 Footer Designed By">
            <el-input v-model.trim="form.footerDesignedBy" />
          </el-form-item>
        </div>

        <el-form-item label="中国工厂地址 China Factory Address">
          <el-input v-model.trim="form.factoryAddressCn" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="塞尔维亚工厂地址 Serbia Factory Address">
          <el-input v-model.trim="form.factoryAddressRs" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="页脚版权文字 Footer Text">
          <el-input v-model.trim="form.footerText" type="textarea" :rows="3" />
        </el-form-item>

        <h3>隐私政策 Privacy Policy</h3>
        <el-form-item label="隐私政策标题 Privacy Policy Title">
          <el-input v-model.trim="form.privacyPolicyTitle" />
        </el-form-item>
        <el-form-item label="隐私政策正文 Privacy Policy Content">
          <el-input v-model.trim="form.privacyPolicyContent" type="textarea" :rows="10" />
        </el-form-item>

        <h3>SEO 信息 SEO</h3>
        <el-form-item label="SEO 标题 SEO Title">
          <el-input v-model.trim="form.seoTitle" />
        </el-form-item>
        <el-form-item label="SEO 描述 SEO Description">
          <el-input v-model.trim="form.seoDescription" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="SEO 关键词 SEO Keywords">
          <el-input v-model.trim="form.seoKeywords" />
        </el-form-item>

        <h3>品牌图片 Brand Images</h3>
        <div class="form-grid">
          <el-form-item label="Logo 图片 Logo Image">
            <div class="image-field">
              <el-input v-model.trim="form.logoImage" placeholder="图片地址 Image URL" />
              <el-upload action="" :http-request="request => uploadImage('logoImage', request)" :show-file-list="false" accept="image/*">
                <el-button size="small" :loading="uploadingTarget === 'logoImage'">上传 Upload</el-button>
              </el-upload>
              <el-button size="small" @click="openMediaPicker('logoImage')">选择 Choose</el-button>
            </div>
            <el-image v-if="form.logoImage" class="image-preview image-preview--logo" :src="assetUrl(form.logoImage)" :preview-src-list="[assetUrl(form.logoImage)]" fit="contain" />
          </el-form-item>
          <el-form-item label="Favicon 图片 Favicon Image">
            <div class="image-field">
              <el-input v-model.trim="form.faviconImage" placeholder="图片地址 Image URL" />
              <el-upload action="" :http-request="request => uploadImage('faviconImage', request)" :show-file-list="false" accept="image/*">
                <el-button size="small" :loading="uploadingTarget === 'faviconImage'">上传 Upload</el-button>
              </el-upload>
              <el-button size="small" @click="openMediaPicker('faviconImage')">选择 Choose</el-button>
            </div>
            <el-image v-if="form.faviconImage" class="image-preview image-preview--icon" :src="assetUrl(form.faviconImage)" :preview-src-list="[assetUrl(form.faviconImage)]" fit="contain" />
          </el-form-item>
        </div>
        <el-form-item label="分享图 Share Image">
          <div class="image-field">
            <el-input v-model.trim="form.shareImage" placeholder="图片地址 Image URL" />
            <el-upload action="" :http-request="request => uploadImage('shareImage', request)" :show-file-list="false" accept="image/*">
              <el-button size="small" :loading="uploadingTarget === 'shareImage'">上传 Upload</el-button>
            </el-upload>
            <el-button size="small" @click="openMediaPicker('shareImage')">选择 Choose</el-button>
          </div>
          <el-image v-if="form.shareImage" class="image-preview image-preview--share" :src="assetUrl(form.shareImage)" :preview-src-list="[assetUrl(form.shareImage)]" fit="cover" />
        </el-form-item>

        <h3>社媒链接 Social Links</h3>
        <p class="settings-hint">留空则官网 Footer 不展示对应社媒。Empty link hides that social icon on the website.</p>
        <div class="form-grid">
          <el-form-item label="WhatsApp">
            <el-input v-model.trim="form.socialWhatsapp" placeholder="https://wa.me/..." />
          </el-form-item>
          <el-form-item label="Instagram">
            <el-input v-model.trim="form.socialInstagram" />
          </el-form-item>
          <el-form-item label="TikTok">
            <el-input v-model.trim="form.socialTiktok" />
          </el-form-item>
          <el-form-item label="Facebook">
            <el-input v-model.trim="form.socialFacebook" />
          </el-form-item>
          <el-form-item label="LinkedIn">
            <el-input v-model.trim="form.socialLinkedin" />
          </el-form-item>
          <el-form-item label="X">
            <el-input v-model.trim="form.socialX" />
          </el-form-item>
        </div>

        <div class="settings-actions">
          <el-button type="primary" :loading="submitting" @click="handleSubmit">保存设置 Save Settings</el-button>
        </div>
      </el-form>
    </section>

    <media-picker-dialog
      :visible.sync="mediaPickerVisible"
      upload-module="site"
      @select="chooseMedia"
    />
  </div>
</template>

<script>
import { fetchSiteSettings, updateSiteSettings } from '../../api/settings'
import { resolveAssetUrl, uploadMediaAsset } from '../../api/media'
import MediaPickerDialog from '../../components/MediaPickerDialog.vue'

const createEmptyForm = () => ({
  siteName: 'STRONGOVA',
  seoTitle: 'STRONGOVA',
  seoDescription: 'STRONGOVA ecological wood flooring.',
  seoKeywords: 'STRONGOVA, wood flooring, ecological wood',
  logoImage: '',
  faviconImage: '',
  shareImage: '',
  footerText: 'CopyRight © 2005-2025 STRONGOVA .All right reserved',
  footerDesignedBy: 'Designed By:SENJU',
  privacyPolicyTitle: 'Privacy Policy',
  privacyPolicyContent: [
    'STRONGOVA respects your privacy and is committed to protecting the personal information you share with us.',
    'We use submitted contact and inquiry information only to respond to your requests, provide product support, and improve our services.',
    'We do not sell your personal information. If you need to update or remove information you have submitted, please contact us by email.'
  ].join('\n\n'),
  contactEmail: 'STRONGOVA@strongova.com',
  contactPhone: '+86 15668650333',
  factoryAddressCn: 'NO.59 HAIXiang Road, Daweijia Street,Jinzhou District,Dalian City.',
  factoryAddressRs: 'Obrenovacki Put 237a, Baric',
  socialWhatsapp: '',
  socialInstagram: '',
  socialTiktok: '',
  socialFacebook: '',
  socialLinkedin: '',
  socialX: ''
})

export default {
  name: 'SiteSettingsView',
  components: {
    MediaPickerDialog
  },
  data () {
    return {
      loading: false,
      submitting: false,
      uploadingTarget: '',
      mediaPickerVisible: false,
      pickerTarget: '',
      form: createEmptyForm()
    }
  },
  async created () {
    await this.loadSettings()
  },
  methods: {
    assetUrl: resolveAssetUrl,
    normalizeSocialForm (data = {}) {
      return {
        ...createEmptyForm(),
        ...data,
        socialWhatsapp: data.socialWhatsapp || data.socialYoutube || ''
      }
    },
    async loadSettings () {
      this.loading = true
      try {
        const { data } = await fetchSiteSettings()
        this.form = this.normalizeSocialForm(data)
      } catch (error) {
        this.$message.error('站点设置加载失败 Failed to load site settings.')
      } finally {
        this.loading = false
      }
    },
    openMediaPicker (target) {
      this.pickerTarget = target
      this.mediaPickerVisible = true
    },
    chooseMedia (item) {
      this.form[this.pickerTarget] = item.fileUrl
      this.mediaPickerVisible = false
    },
    async uploadImage (target, { file }) {
      if (this.uploadingTarget) return
      this.uploadingTarget = target
      try {
        const { data } = await uploadMediaAsset(file, 'site')
        this.form[target] = data.fileUrl
        this.$message.success('图片已上传 Image uploaded.')
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || '上传失败 Upload failed.')
      } finally {
        this.uploadingTarget = ''
      }
    },
    async handleSubmit () {
      if (this.submitting) return
      this.submitting = true
      try {
        const { data } = await updateSiteSettings(this.form)
        this.form = this.normalizeSocialForm(data)
        this.$message.success('站点设置已保存 Site settings saved.')
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || '保存失败 Save failed.')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.settings-card {
  padding: 24px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--panel);
  box-shadow: 0 16px 32px rgba(23, 20, 17, 0.04);
}

.settings-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 22px;
}

.settings-card h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
}

.settings-card p {
  margin: 8px 0 0;
  color: var(--muted);
}

.settings-card h3 {
  margin: 26px 0 16px;
  padding-top: 18px;
  border-top: 1px solid var(--line);
  font-size: 16px;
  font-weight: 500;
}

.settings-card h3:first-of-type {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

.settings-hint {
  margin: -6px 0 14px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.6;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.image-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.image-preview {
  margin-top: 10px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f7f3ed;
}

.image-preview--logo {
  width: 180px;
  height: 72px;
}

.image-preview--icon {
  width: 72px;
  height: 72px;
}

.image-preview--share {
  width: 240px;
  height: 135px;
}

.settings-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .settings-card__head,
  .form-grid {
    grid-template-columns: 1fr;
  }

  .settings-card__head {
    flex-direction: column;
  }

  .image-field {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
